import axios from 'axios';
import config from '../config';

const API_BASE_URL = `${config.API_BASE_URL}/Rentals`;

// ══════════════════════════════════════════
// RENTAL PRODUCTS
// ══════════════════════════════════════════

export const fetchRentalProducts = async (branchId, currency = 'YER') => {
  const params = [];
  if (branchId) params.push(`branchId=${branchId}`);
  if (currency) params.push(`currency=${currency}`);
  
  const query = params.length > 0 ? `?${params.join('&')}` : '';
  const response = await axios.get(`${API_BASE_URL}/products${query}`);
  return response.data;
};

export const checkRentalAvailability = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/check-availability`, data);
  return response.data;
};

// ══════════════════════════════════════════
// RENTAL ORDERS
// ══════════════════════════════════════════

export const createRentalOrder = async (orderData) => {
  const response = await axios.post(`${API_BASE_URL}/orders`, orderData);
  return response.data;
};

export const fetchAllRentals = async (branchId, status, page = 1, limit = 50) => {
  const params = [];
  if (branchId) params.push(`branchId=${branchId}`);
  if (status) params.push(`status=${status}`);
  params.push(`page=${page}`);
  params.push(`limit=${limit}`);
  
  const query = `?${params.join('&')}`;
  const response = await axios.get(`${API_BASE_URL}/orders${query}`);
  return response.data;
};

export const fetchCustomerRentals = async (customerId, currency = 'YER', status) => {
  const params = [`currency=${currency}`];
  if (status) params.push(`status=${status}`);
  
  const query = `?${params.join('&')}`;
  const response = await axios.get(`${API_BASE_URL}/orders/customer/${customerId}${query}`);
  return response.data;
};

export const updateRentalStatus = async (rentalId, data) => {
  const response = await axios.put(`${API_BASE_URL}/orders/${rentalId}/status`, data);
  return response.data;
};

export const cancelRental = async (rentalId, customerId) => {
  const response = await axios.post(`${API_BASE_URL}/orders/${rentalId}/cancel`, { CustomerId: customerId });
  return response.data;
};

// ══════════════════════════════════════════
// CONFIG & STATS
// ══════════════════════════════════════════

export const fetchRentalPriceTypes = async () => {
  const response = await axios.get(`${API_BASE_URL}/price-types`);
  return response.data;
};

export const fetchRentalStats = async (branchId) => {
  const params = branchId ? `?branchId=${branchId}` : '';
  const response = await axios.get(`${API_BASE_URL}/stats${params}`);
  return response.data;
};

// ══════════════════════════════════════════
// PRODUCT CRUD (uses Product API for create/update)
// ══════════════════════════════════════════

const PRODUCT_API = `${config.API_BASE_URL}/Product`;

export const createRentalProduct = async (productData) => {
  const response = await axios.post(PRODUCT_API, {
    ...productData,
    IsRental: true
  });
  return response.data;
};

export const updateRentalProduct = async (id, productData) => {
  const response = await axios.put(`${PRODUCT_API}/EditProduct/${id}`, {
    ...productData,
    IsRental: true
  });
  return response.data;
};

export const deleteRentalProduct = async (id) => {
  const response = await axios.delete(`${PRODUCT_API}/${id}`);
  return response.data;
};

export const fetchRentalProductById = async (id) => {
  const response = await axios.get(`${PRODUCT_API}/${id}`);
  return response.data;
};